import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  filter: {
    width: 380,
  },
  endAdornment: {
    '& .MuiSvgIcon-root': {
      color: '#000 !important',
    },
  },
}));
